import $ from 'jquery';

/* eslint-disable */

class HelpCentre {
  constructor(){
    if (document.querySelector('[data-dispute-summary]')) {
      $(function(){
        // .closest polyfill
        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                      Element.prototype.webkitMatchesSelector;
        }
        if (!Element.prototype.closest) {
          Element.prototype.closest = function(s) {
            var el = this;

            do {
              if (Element.prototype.matches.call(el, s)) return el;
              el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
          };
        }

        if($('form#request-form').length>0) {
          $('form').on('submit', handleSubmit);
        }

        var currentClickedButton;
        var form = document.querySelector('#request-form');
        var submitButtons = form.querySelectorAll('button');

        // our forEach helper function
        //////////////////////////////
        var forEach = function (array, callback, scope) {
          for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
          }
        };

        var _buttonClick = function(e) {
          currentClickedButton = e.target
          applyRequiredAttrToSiblings();
        }

        // Attach the event listener to all instances of the selector
        forEach(submitButtons, function (i, el) {
          // Should fire on both click and 'enter' keydown
          el.addEventListener('click', _buttonClick);
        });

        function handleSubmit(e) {
          e.preventDefault();

          if (checkDoorsInSituUploads(e) && checkFileSize(e) && checkCommentPresent(e)) {
            buildAndSendForm(e);
            clearAndCloseForm(e);
          }
        }

        function checkDoorsInSituUploads(e) {
          var disputeId = getDisputeId(e);

          var confirmCheckbox = $('div[data-dispute-id=' + disputeId + '] input[name="dispute_form_builder[confirm_doors_and_in_situ_uploaded]"]');

          if (confirmCheckbox.length == 0) {
            // This form doesn't have this field - not required - so can return now
            return true;
          }

          var uploadDoor = $('div[data-dispute-id=' + disputeId + '] input[name="dispute_form_builder[upload_doors]"]');
          fileDoorTooBigMsg(uploadDoor, false);
          if ((uploadDoor[0].files.length > 0) && (uploadDoor[0].files[0].size > 5242880)) {
            return fileDoorTooBigMsg(uploadDoor, true);
          }

          var uploadInSitu = $('div[data-dispute-id=' + disputeId + '] input[name="dispute_form_builder[upload_in_situ]"]');
          fileInSituTooBigMsg(uploadInSitu, false);
          if ((uploadInSitu[0].files.length > 0) && (uploadInSitu[0].files[0].size > 5242880)) {
            return fileInSituTooBigMsg(uploadInSitu, true);
          }

          if (!confirmCheckbox.prop('checked')) {
            return uploadsCheckboxMsg(confirmCheckbox, true);
          }

          return true;
        }

        function checkFileSize(e) {
          var disputeId = getDisputeId(e);

          //reset the attachment too big message
          var fileUpload = $('div[data-dispute-id=' + disputeId + '] input[type=file]');
          fileTooBigMsg(fileUpload, false);

          var too_big = 0

          $.each(['','2','3','4','5'], function(_i, v) {
            var upload = $('div[data-dispute-id=' + disputeId + '] input[name="dispute_form_builder[upload' + v + ']"]');

            if ((upload[0].files.length > 0) && (upload[0].files[0].size > 5242880)) {
              too_big += 1;
            }
          });

          if (too_big > 0) {
            return fileTooBigMsg(fileUpload, true);
          }

          return true;
        }

        function checkCommentPresent(e) {
          var disputeId = getDisputeId(e);
          var textarea = $('div[data-dispute-id=' + disputeId + ']').find('textarea');

          commentMissing(textarea, false);

          if (!$(textarea).val()) {
            return commentMissing(textarea, true);
          }
          return true;
        }

        function applyRequiredAttrToSiblings() {
          var disputeId = getDisputeId();

          $('input[type=radio], input[type=file]').removeAttr('required');
          $('div[data-dispute-id=' + disputeId + '] input[type=radio]').attr('required', 'required');
          if (!([2, 3, 4].indexOf(parseInt(disputeId))>-1)) {
            $('div[data-dispute-id=' + disputeId + '] input[type=file]:not(.ds)').first().attr('required', 'required');
          }
          if (([1, 6, 8, 9, 10].indexOf(parseInt(disputeId))>-1)) {
            $('div[data-dispute-id=' + disputeId + '] input[name="dispute_form_builder[upload_doors]"]').attr('required', 'required');
            $('div[data-dispute-id=' + disputeId + '] input[name="dispute_form_builder[upload_in_situ]"]').attr('required', 'required');
          }
        }

        function buildAndSendForm(e) {
          var disputeId = getDisputeId(e);
          var details = fetchDetail();
          var dispute = fetchDispute(disputeId);
          var body = details.add(dispute);
          var form = buildForm();

          $(form).append(body);
          $(form).appendTo('body');
          $(form).trigger('submit');
        }

        function clearAndCloseForm(e) {
          var disputeId = getDisputeId(e);
          var wrapDiv = $('div[data-dispute-id=' + disputeId + ']');
          var summary = $('summary[data-dispute-summary=' + disputeId + ']');
          var thankYouMessage = $("<p>Thanks for using our help centre. We'll be in touch with you shortly</p>").addClass('help-centre__thanks-message');

          $(wrapDiv).find('input[type=file], textarea').val('');
          $(wrapDiv).find('input[type=radio]').attr('checked', false);
          $(wrapDiv).find('input[type=checkbox]').attr('checked', false);
          $(summary).trigger('click');
          $(summary).parents('details')
                    .addClass('help-centre__dispute--completed');
          $(summary).append(thankYouMessage);
          $('html, body').animate({scrollTop: summary.offset().top - 150}, 1000);
        }

        function buildForm() {
          var formAttributes = $('#request-form').prop('attributes');

          var form = $('<form/>');
          $(form).css('display', 'none');

          $.each(formAttributes, function(_i, att) {
            if (!(att.name == 'id')) {
              $(form).attr(att.name, att.value);
            }
          });

          $(form).append($('<input/>').attr({name: 'utf8', value: '✓'}));

          $(form).append(fetchAuthToken());

          return $(form);
        }

        function fetchDetail() {
          return $('[data-details]').find('input, textarea').clone();
        }

        function fetchDispute(disputeId) {
          var inputs = $('div[data-dispute-id=' + disputeId + ']').find(
            'input[type=text], input[type=date], input[type=radio]:checked, input[type=checkbox]:checked,'
            + 'textarea, input[type=hidden], input[type=file]'
          ).clone();
          // Cant clone file uploaders in safari, I'll let you fix this, tim :)
          if ((navigator.userAgent.indexOf('afari')>1) && (navigator.userAgent.indexOf('hrom') === -1)) {
            inputs.append($('div[data-dispute-id=' + disputeId + ']').find('input[type=file]'))
          }
          return inputs;
        }

        function fetchAuthToken(){
          return $('input[name=authenticity_token]').clone();
        }

        function fileTooBigMsg(fileUpload, toggle) {
          var warningSpan = $(fileUpload).parents('div[data-dispute-id]').find('span[data-warning-file]');
          $(warningSpan).empty();
          if (toggle){
            $(warningSpan).text(' - ERROR: Filesize is too large, please select a different file.');
          }
          return !toggle;
        }

        function fileDoorTooBigMsg(fileUpload, toggle) {
          var warningSpan = $(fileUpload).parents('div[data-dispute-id]').find('span[data-warning-upload-doors]');
          $(warningSpan).empty();
          if (toggle){
            $(warningSpan).text(' - ERROR: Filesize is too large, please select a different file.');
          }
          return !toggle;
        }

        function fileInSituTooBigMsg(fileUpload, toggle) {
          var warningSpan = $(fileUpload).parents('div[data-dispute-id]').find('span[data-warning-upload-in-situ]');
          $(warningSpan).empty();
          if (toggle){
            $(warningSpan).text(' - ERROR: Filesize is too large, please select a different file.');
          }
          return !toggle;
        }

        function commentMissing(textarea, toggle) {
          var warningSpan = $(textarea).parents('div[data-dispute-id]').find('span[data-warning-message]');
          $(warningSpan).empty();
          if (toggle){
            $(warningSpan).text(' - ERROR: Please supply some detail about your dispute.');
          }
          return !toggle;
        }

        function uploadsCheckboxMsg(checkbox, toggle) {
          var warningSpan = $(checkbox).parents('div[data-dispute-id]').find('span[data-warning-upload-checkbox]');
          $(warningSpan).empty();
          if (toggle){
            $(warningSpan).text(' - ERROR: You must confirm you have uploaded both photos.');
          }
          return !toggle;
        }

        function getDisputeId() {
          var outerDiv = currentClickedButton.closest('[data-dispute-id]');
          var questionId = outerDiv.getAttribute('data-dispute-id');
          return questionId;
        }
      });
    };
  }
}

export default HelpCentre;
